import { CircularProgress } from "@mui/material";
import "./css/Loader.scss";

interface IThisProps {
    size?: number;
    thickness?: number;
}

export const Loader = ({ size = 80, thickness = 3 }: IThisProps) => (
    <div className="loader" data-testid="loader">
        <CircularProgress color="inherit" size={size} thickness={thickness} variant="indeterminate" />
    </div>
);
